module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Snoozed-mail-845f3ba500fd65982f41fa89a0e45320.svg";